<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper dq-platform">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/super-admin/companies"
                class="btn btn-icon btn-sm me-1"
              >
                <i class="ti ti-list-tree"></i>
              </router-link>
              <router-link
                to="/super-admin/companies-grid"
                class="btn btn-icon btn-sm active bg-primary text-white"
              >
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div>
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="exportCompanies('pdf')">
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="exportCompanies('excel')">
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              @click="openAddModal"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Company
            </a>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="card">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between">
            <h5>Companies Grid</h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ currentSort }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li v-for="option in sortOptions" :key="option">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="currentSort = option"
                  >
                    {{ option }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div
        v-if="loading"
        class="d-flex justify-content-center align-items-center py-5"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Companies Grid -->
      <div v-else class="row">
        <div
          v-for="company in displayedCompanies"
          :key="company.id"
          class="col-xl-3 col-lg-4 col-md-6 mb-4"
        >
          <div class="card h-100">
            <div class="card-body">
              <div
                class="d-flex justify-content-between align-items-start mb-2"
              >
                <div class="form-check form-check-md">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="company.id"
                    v-model="selectedCompanies"
                  />
                </div>
                <div>
                  <router-link
                    :to="`/super-admin/companies-details/${company.id}`"
                    class="avatar avatar-xl avatar-rounded border rounded-circle"
                  >
                    <img
                      v-if="company.logo_url"
                      :src="company.logo_url"
                      class="img-fluid h-auto w-auto"
                      :alt="company.company_name"
                    />
                    <div
                      v-else
                      class="d-flex align-items-center justify-content-center h-100 bg-light text-muted"
                    >
                      <i class="ti ti-building fs-24"></i>
                    </div>
                  </router-link>
                </div>
                <div class="dropdown">
                  <button
                    class="btn btn-icon btn-sm rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end p-3">
                    <a
                      class="dropdown-item rounded-1"
                      href="javascript:void(0);"
                      :class="{ disabled: impersonatingId === company.id }"
                      @click="
                        impersonatingId === company.id
                          ? null
                          : loginAsCompany(company)
                      "
                    >
                      <i class="ti ti-login me-1"></i>
                      {{
                        impersonatingId === company.id
                          ? "Logging in..."
                          : "Login as Company"
                      }}
                    </a>

                    <li>
                      <a
                        class="dropdown-item rounded-1"
                        href="javascript:void(0);"
                        @click="openEditModal(company)"
                      >
                        <i class="ti ti-edit me-1"></i>Edit
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item rounded-1"
                        href="javascript:void(0);"
                        @click="setDeleteCompany(company)"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_modal"
                      >
                        <i class="ti ti-trash me-1"></i>Delete
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="text-center mb-3">
                <h6 class="mb-1">
                  <router-link :to="`/super-admin/companies-details/${company.id}`">
                    {{ company.company_name }}
                  </router-link>
                </h6>

                <!-- Company Status -->
                <span :class="statusClass(company.status)" class="mb-2">
                  <i class="ti ti-point-filled me-1"></i>{{ company.status }}
                </span>

                <!-- Employee Avatars (if you have employees data) -->
                <div
                  v-if="company.employees && company.employees.length"
                  class="avatar-list-stacked avatar-group-sm mt-2"
                >
                  <span
                    v-for="(employee, index) in company.employees.slice(0, 5)"
                    :key="employee.id || index"
                    class="avatar avatar-rounded"
                  >
                    <img
                      class="border border-white"
                      :src="
                        employee.avatar ||
                        '@/assets/img/profiles/avatar-default.jpg'
                      "
                      :alt="employee.name"
                    />
                  </span>
                  <a
                    v-if="company.employees.length > 5"
                    class="avatar bg-primary avatar-rounded text-fixed-white fs-12"
                    href="javascript:void(0);"
                  >
                    +{{ company.employees.length - 5 }}
                  </a>
                </div>
              </div>

              <div class="d-flex flex-column">
                <p
                  v-if="company.email"
                  class="text-dark d-inline-flex align-items-center mb-2"
                >
                  <i class="ti ti-mail-forward text-gray-5 me-2"></i>
                  {{ company.email }}
                </p>
                <p
                  v-if="company.phone"
                  class="text-dark d-inline-flex align-items-center mb-2"
                >
                  <i class="ti ti-phone text-gray-5 me-2"></i>
                  {{ company.phone }}
                </p>
                <p
                  v-if="company.address || (company.state && company.country)"
                  class="text-dark d-inline-flex align-items-center"
                >
                  <i class="ti ti-map-pin text-gray-5 me-2"></i>
                  {{
                    company.address || `${company.state}, ${company.country}`
                  }}
                </p>
              </div>

              <div
                class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"
              >
                <div class="icons-social d-flex align-items-center">
                  <a
                    v-if="company.email"
                    :href="`mailto:${company.email}`"
                    class="avatar avatar-rounded avatar-sm me-1"
                  >
                    <i class="ti ti-mail"></i>
                  </a>
                  <a
                    v-if="company.phone"
                    :href="`tel:${company.phone}`"
                    class="avatar avatar-rounded avatar-sm me-1"
                  >
                    <i class="ti ti-phone-call"></i>
                  </a>
                  <a
                    v-if="company.whatsapp_profile"
                    :href="`https://wa.me/${company.whatsapp_profile}`"
                    class="avatar avatar-rounded avatar-sm me-1"
                    target="_blank"
                  >
                    <i class="ti ti-message-2"></i>
                  </a>
                  <a
                    v-if="company.skype_profile"
                    :href="`skype:${company.skype_profile}?chat`"
                    class="avatar avatar-rounded avatar-sm me-1"
                  >
                    <i class="ti ti-brand-skype"></i>
                  </a>
                  <a
                    v-if="company.facebook_profile"
                    :href="company.facebook_profile"
                    target="_blank"
                    class="avatar avatar-rounded avatar-sm"
                  >
                    <i class="ti ti-brand-facebook"></i>
                  </a>
                </div>

                <!-- Rating (if you have rating data) -->
                <span
                  v-if="company.rating"
                  class="d-inline-flex align-items-center"
                >
                  <i class="ti ti-star-filled text-warning me-1"></i
                  >{{ company.rating }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div
        v-if="!loading && companyStore.companies.length === 0"
        class="text-center py-5"
      >
        <div class="mb-4">
          <i class="ti ti-building fs-48 text-muted"></i>
        </div>
        <h5 class="mb-2">No Companies Found</h5>
        <p class="text-muted mb-4">Get started by adding your first company.</p>
        <button @click="openAddModal" class="btn btn-primary">
          <i class="ti ti-circle-plus me-2"></i>Add Company
        </button>
      </div>

      <!-- Load More Button -->
      <div v-if="hasMoreCompanies" class="text-center mb-4">
        <button
          @click="loadMore"
          class="btn btn-white border"
          :disabled="loadingMore"
        >
          <i
            class="ti ti-loader-3 text-primary me-2"
            :class="{ spin: loadingMore }"
          ></i>
          {{ loadingMore ? "Loading..." : "Load More" }}
        </button>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- Include the modal component -->
  <companies-crm-modal
    :company="editCompany"
    :delete-company="deleteCompany"
    @company-updated="refreshCompanyList"
    @modal-closed="clearEditCompany"
  />
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from "vue";
import { useCompanyStore } from "@/stores/companyStore";
import * as bootstrap from "bootstrap";
import { useAuthStore } from "@/stores/authStore";
import { useRouter } from "vue-router";
import companyService from "@/services/super-admin/companyService";
import { toast } from "@/utils/toast";

// Constants
const title = ref("Companies");
const text = ref("Superadmin");
const text1 = ref("Companies Grid");

// Store
const authStore = useAuthStore();
const router = useRouter();

const companyStore = useCompanyStore();
const loading = ref(false);
const loadingMore = ref(false);
const editCompany = ref(null);
const deleteCompany = ref(null);
const selectedCompanies = ref([]);

// Pagination
const companiesPerPage = 8;
const currentPage = ref(1);

const impersonatingId = ref(null);

const loginAsCompany = async (company) => {
  try {
    impersonatingId.value = company.id;
    await authStore.impersonateCompany(company.id);

    // route like a real admin would
    await router.push("/dashboard/admin-dashboard");
  } catch (e) {
    console.error(e);
  } finally {
    impersonatingId.value = null;
  }
};

// Sorting
const currentSort = ref("Recently Added");
const sortOptions = ref([
  "Recently Added",
  "Ascending",
  "Descending",
  "Last Month",
  "Last 7 Days",
]);

// Computed Properties
const sortedCompanies = computed(() => {
  let companies = [...companyStore.companies];

  switch (currentSort.value) {
    case "Ascending":
      companies.sort((a, b) => a.company_name.localeCompare(b.company_name));
      break;
    case "Descending":
      companies.sort((a, b) => b.company_name.localeCompare(a.company_name));
      break;
    case "Recently Added":
      companies.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      break;
    case "Last Month": {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);
      companies = companies.filter((company) => {
        const created = new Date(company.created_at);
        return created >= start && created <= end;
      });
      break;
    }
    case "Last 7 Days":
      // Filter companies from last 7 days
      const lastWeek = new Date();
      lastWeek.setDate(lastWeek.getDate() - 7);
      companies = companies.filter(
        (company) => new Date(company.created_at) >= lastWeek
      );
      break;
  }

  return companies;
});

const displayedCompanies = computed(() => {
  return sortedCompanies.value.slice(0, currentPage.value * companiesPerPage);
});

const hasMoreCompanies = computed(() => {
  return sortedCompanies.value.length > displayedCompanies.value.length;
});

// Methods
const toggleHeader = () => {
  document.getElementById("collapse-header").classList.toggle("active");
  document.body.classList.toggle("header-collapse");
};

const statusClass = (status) => {
  return status === "Active"
    ? "badge badge-success d-inline-flex align-items-center badge-xs"
    : "badge badge-danger d-inline-flex align-items-center badge-xs";
};

const setDeleteCompany = (company) => {
  deleteCompany.value = company;
};

const clearEditCompany = () => {
  editCompany.value = null;
  deleteCompany.value = null;
};

const openAddModal = () => {
  clearEditCompany();

  nextTick(() => {
    const modal = new bootstrap.Modal(document.getElementById("add_company"));
    modal.show();
  });
};

const openEditModal = (company) => {
  clearEditCompany();

  nextTick(() => {
    editCompany.value = { ...company };

    nextTick(() => {
      const modal = new bootstrap.Modal(document.getElementById("add_company"));
      modal.show();
    });
  });
};

const loadMore = () => {
  loadingMore.value = true;

  // Simulate loading delay
  setTimeout(() => {
    currentPage.value += 1;
    loadingMore.value = false;
  }, 500);
};

const refreshCompanyList = async () => {
  loading.value = true;
  try {
    await companyStore.fetchCompanies();
  } catch (error) {
    console.error("Error fetching companies:", error);
  } finally {
    loading.value = false;
  }
};

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const exportCompanies = async (format) => {
  try {
    const res = await companyService.export({}, format);
    downloadBlob(
      res.data,
      format === "pdf" ? "companies-export.pdf" : "companies-export.xlsx"
    );
  } catch (error) {
    toast(
      error?.response?.data?.message || "Failed to export companies",
      "error"
    );
  }
};

// Lifecycle hooks
onMounted(() => {
  refreshCompanyList();
});
</script>

<style scoped>
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.avatar-list-stacked {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
}

.avatar-list-stacked .avatar {
  margin-left: -0.25rem;
}

.avatar-list-stacked .avatar:first-child {
  margin-left: 0;
}

.icons-social a {
  transition: all 0.2s ease-in-out;
}

.icons-social a:hover {
  transform: scale(1.1);
  background-color: var(--bs-primary);
  color: white !important;
}
</style>


